













































































































































































































































































































































































































































































import Vue from 'vue';
import max from 'lodash/max';
import min from 'lodash/min';
import sum from 'lodash/sum';
import groupBy from 'lodash/groupBy';
import cloneDeep from 'lodash/cloneDeep';
import ItemTooltip from '@/components/item/ItemTooltip.vue';
import BarChart, { BarGraphData, LabelCallbackArg } from '@/components/graph/Bar.vue';
import CalcManager from '@/classes/calcManager';
import SaveData from '@/classes/saveData/saveData';
import ItemMaster from '@/classes/item/itemMaster';
import ShipMaster from '@/classes/fleet/shipMaster';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import Airbase from '@/classes/airbase/airbase';
import Enemy from '@/classes/enemy/enemy';
import Ship from '@/classes/fleet/ship';
import Item from '@/classes/item/item';
import Calculator, { FirePowerCalcArgs, PowerDist, SlotDist } from '@/classes/aerialCombat/powerCalculator';
import CommonCalc from '@/classes/commonCalc';
import { SHIP_TYPE } from '@/classes/const';
import FleetInfo from '@/classes/fleet/fleetInfo';
import BattleInfo from '@/classes/enemy/battleInfo';
import SiteSetting from '@/classes/siteSetting';

const labelCallback = (c: LabelCallbackArg) => `${c.formattedValue} %`;

interface DamageRowData {
  ship: Ship | Enemy;
  damage: string;
  death: number;
  taiha: number;
  chuha: number;
  disabledASW: boolean;
}

export default Vue.extend({
  name: 'PlaneDetailResult',
  components: { BarChart, ItemTooltip },
  props: {
    parent: {
      type: [Ship, Airbase, Enemy],
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    fleetIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    visibleSlotRate: true,
    calcManager: undefined as undefined | CalcManager,
    selectedIndex: -1,
    selectedItem: new Item(),
    graphData: {
      labels: [''],
      datasets: [
        {
          yAxisID: 'main',
          label: 'Probability Distribution',
          data: [0],
          backgroundColor: 'rgba(255, 120, 180, 0.4)',
          datalabels: { display: false, color: '#000' },
        },
        {
          yAxisID: 'sub',
          label: 'Cummulative Probability',
          data: [0],
          type: 'line',
          fill: false,
          borderColor: 'rgb(54, 162, 255)',
          datalabels: { display: false, color: '#000' },
          lineTension: 0.3,
        },
      ],
    } as BarGraphData,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          scaleLabel: { display: true, labelString: 'Cummulative Probability [%]' },
          grid: { color: 'rgba(128, 128, 128, 0.4)' },
          title: { display: true, text: 'Number of Remaining Aircraft [Slot]' },
        },
        main: {
          type: 'linear',
          position: 'left',
          beginAtZero: true,
          max: 100,
          min: 0,
          grid: { color: 'rgba(255, 128, 128, 0.4)' },
          title: { display: true, text: 'Probability Distribution [%]' },
        },
        sub: {
          type: 'linear',
          position: 'right',
          beginAtZero: true,
          max: 100,
          min: 0,
          grid: { color: 'rgba(128, 128, 255, 0.4)' },
          title: { display: true, text: 'Cummulative Probability [%]' },
        },
      },
      plugins: {
        legend: { display: false },
        title: { display: true },
        tooltip: { callbacks: { label: labelCallback } },
      },
    },
    attackerSlot: 18,
    useResult: true,
    calcArgs: {
      isCritical: false,
      isUnion: false,
      criticalBonus: 1,
      contactBonus: 1,
      unionBonus: 1,
      rikuteiBonus: 1,
      specialBonus: 1,
      beforeCapBonus: 1,
      afterCapBonus: 1,
      torpedoBonus: 1,
    } as FirePowerCalcArgs,
    contacts: [
      { text: 'None (100%)', value: 1 },
      { text: '120%', value: 1.2 },
      { text: '117%', value: 1.17 },
      { text: '112%', value: 1.12 },
    ],
    ammo: 1,
    ammos: [
      { text: '～50%', value: 1 },
      { text: '～45%', value: 0.9 },
      { text: '～40%', value: 0.8 },
      { text: '～35%', value: 0.7 },
      { text: '～30%', value: 0.6 },
      { text: '～25%', value: 0.5 },
      { text: '～20%', value: 0.4 },
      { text: '～15%', value: 0.3 },
      { text: '～10%', value: 0.2 },
      { text: '～5%', value: 0.1 },
    ],
    rikuteis: [
      { text: 'None', value: 1 },
      { text: 'Type 2 LBR', value: 1.125 },
      { text: 'Type 2 LBR (Skilled)', value: 1.15 },
    ],
    isAirbase: false,
    defenseIndex: 0,
    defenseFleets: [] as { text: string; value: number; ships: Ship[] | Enemy[]; isUnion: boolean }[],
    enabledTooltip: false,
    slotRateTableText: '',
    tooltipTimer: undefined as undefined | number,
    tooltipItem: new Item(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  mounted() {
    const saveData = this.$store.state.mainSaveData as SaveData;
    const items = this.$store.state.items as ItemMaster[];
    const ships = this.$store.state.ships as ShipMaster[];
    const enemies = this.$store.getters.getEnemies as EnemyMaster[];

    this.calcManager = saveData.loadManagerData(items, ships, enemies);

    this.defenseFleets = [];
    if (this.parent instanceof Enemy) {
      // 防御側セレクトに味方艦隊をセット
      this.defenseFleets = [];
      const { fleets } = this.calcManager.fleetInfo;
      if (this.calcManager.fleetInfo.unionFleet && this.calcManager.fleetInfo.unionFleet.ships.length) {
        const enabledShips = this.calcManager.fleetInfo.unionFleet.ships.filter((v) => !v.isEmpty);
        this.defenseFleets.push({
          text: 'Combined Fleet',
          value: 0,
          ships: enabledShips,
          isUnion: true,
        });
      }
      for (let i = 0; i < fleets.length - 1; i += 1) {
        const enabledShips = fleets[i].ships.filter((v) => !v.isEmpty);
        this.defenseFleets.push({
          text: `Fleet ${i + 1}`,
          value: this.defenseFleets.length,
          ships: enabledShips,
          isUnion: false,
        });
      }
    } else {
      const { fleets } = this.calcManager.battleInfo;
      // 防御側セレクトに敵艦隊をセット
      for (let i = 0; i < fleets.length; i += 1) {
        const enabledShips = fleets[i].enemies.filter((v) => v.data.id);
        this.defenseFleets.push({
          text: `Node ${i + 1}`,
          value: i,
          ships: enabledShips,
          isUnion: fleets[i].isUnion,
        });
      }

      if (this.parent instanceof Airbase) {
        this.isAirbase = true;
        const target = Math.min(this.parent.battleTarget[1], this.calcManager.battleInfo.fleets.length - 1);
        this.defenseIndex = target;
        // 陸上偵察機初期値設定
        if (this.parent.items.some((v) => v.data.id === 312)) {
          this.calcArgs.rikuteiBonus = 1.15;
        } else if (this.parent.items.some((v) => v.data.id === 311)) {
          this.calcArgs.rikuteiBonus = 1.125;
        }
      } else {
        // 通常艦隊 最終戦闘をセット
        this.defenseIndex = this.calcManager.battleInfo.fleets.length - 1;
        // 表示艦隊を調整
        this.calcManager.fleetInfo = new FleetInfo({ info: this.calcManager.fleetInfo, mainFleetIndex: this.fleetIndex });
        // 熟練度クリティカルボーナス算出
        this.calcArgs.criticalBonus = this.parent.getProfCriticalBonus();
      }
    }

    const fleet = this.defenseFleets[this.defenseIndex];
    this.calcArgs.isUnion = fleet.isUnion;

    // ないとバグる 意味不明！！！！！！！！！！！！！！！
    setTimeout(() => {
      // 最初の攻撃機
      const attackerIndex = this.parent.items.findIndex((v) => v.data.isAttacker);
      if (attackerIndex >= 0) {
        this.selectItem(attackerIndex);
      } else {
        // なければ艦載機
        const index = this.parent.items.findIndex((v) => v.data.isPlane);
        this.selectItem(Math.max(0, index));
      }
    }, 50);
  },
  computed: {
    defenseShipRows(): DamageRowData[] {
      const item = this.defenseFleets[this.defenseIndex];
      if (!item) {
        return [];
      }
      const results = [];
      for (let i = 0; i < item.ships.length; i += 1) {
        results.push({
          ship: item.ships[i],
          damage: '',
          death: 0,
          taiha: 0,
          chuha: 0,
          disabledASW: false,
        });
      }
      return results;
    },
  },
  methods: {
    selectItem(index: number) {
      if (index < 0 || this.selectedIndex === index) {
        return;
      }
      this.selectedIndex = index;
      this.setGraphData();
    },
    setGraphData() {
      if (!this.calcManager) {
        return;
      }
      const index = this.selectedIndex;
      let item: Item;
      // この艦載機情報の詳細計算フラグを立て、計算を行う
      if (this.parent instanceof Ship) {
        // 艦隊
        item = this.calcManager.fleetInfo.mainFleet.ships[this.index].items[index];
      } else if (this.parent instanceof Airbase) {
        // 基地
        this.calcManager.airbaseInfo.airbases[this.index].needShootDown = true;
        item = this.calcManager.airbaseInfo.airbases[this.index].items[index];
      } else {
        // 敵
        this.calcManager.mainBattle = this.fleetIndex;
        item = this.calcManager.battleInfo.fleets[this.fleetIndex].enemies[this.index].items[index];
      }

      if (item) {
        item.needRecord = true;
      }

      // 計算実行
      this.calcManager.updateInfo();

      if (item) {
        this.selectedItem = cloneDeep(item);
        // 集計
        const dist = groupBy(item.dist);
        const sumDist = item.dist.length;
        // リセット
        item.dist = [];

        // 確率分布
        const rates: number[] = [];
        // 累積確率
        let sumRate = 0;
        const sumRates: number[] = [];
        const labels: string[] = [];

        Object.keys(dist).forEach((key) => {
          labels.push(`${key}`);
          const rate = dist[key].length / sumDist;
          sumRate += rate;
          rates.push(Math.floor(1000 * rate) / 10);
          sumRates.push(Math.round(100 * sumRate));
        });

        this.slotRateTableText = '';
        for (let i = item.fullSlot; i >= 0; i -= 1) {
          const slot = dist[`${i}`];
          if (slot) {
            this.slotRateTableText += `${i}\t${slot.length / sumDist}\r\n`;
          } else {
            this.slotRateTableText += `${i}\t${0}\r\n`;
          }
        }

        const maxRate = +(max(rates) || 100);
        this.options.scales.main.max = Math.min(Math.floor(10 * Math.ceil(maxRate / 10)), 100);

        this.graphData.labels = labels;
        this.graphData.datasets[0].data = rates;
        this.graphData.datasets[1].data = sumRates;

        this.attackerSlot = item.fullSlot;
      }

      this.calculateFire();
    },
    changeDefenseIndex() {
      const item = this.defenseFleets[this.defenseIndex];
      if (!item) {
        return;
      }
      this.calcArgs.isUnion = item.isUnion;

      if (this.parent instanceof Ship && this.calcManager) {
        // 展開している敵艦隊までの計算に変更
        const saveData = this.$store.state.mainSaveData as SaveData;
        const items = this.$store.state.items as ItemMaster[];
        const ships = this.$store.state.ships as ShipMaster[];
        const enemies = this.$store.getters.getEnemies as EnemyMaster[];
        const baseInfo = saveData.loadManagerData(items, ships, enemies).battleInfo;

        this.calcManager.mainBattle = this.defenseIndex;
        this.calcManager.battleInfo = new BattleInfo({ info: baseInfo, fleets: baseInfo.fleets.slice(0, this.defenseIndex + 1) });
      }
      this.setGraphData();
    },
    calculateFire() {
      const tempDist = this.selectedItem.dist;
      const { attackerTorpedoBonus } = this.selectedItem;
      // 改修値 搭載数変更を適用して再インスタンス化
      this.selectedItem = new Item({ item: this.selectedItem, slot: this.attackerSlot });
      // 雷装ボーナスあれば
      this.selectedItem.attackerTorpedoBonus = attackerTorpedoBonus;
      // 計算結果の分布を引継ぎ
      this.selectedItem.dist = tempDist;

      const item = this.selectedItem;

      // 搭載数分布オブジェクト作成
      const sumDist = this.selectedItem.dist.length;
      const slotDist: SlotDist[] = [];
      const data = groupBy(this.selectedItem.dist);

      if (this.useResult) {
        // 搭載数分布の結果を利用
        Object.keys(data).forEach((key) => {
          slotDist.push({ slot: +key, rate: data[key].length / sumDist });
        });
      } else {
        // 搭載数キメ打ち
        slotDist.push({ slot: item.fullSlot, rate: 1 });
      }
      const maxSlot = +(this.useResult ? max(Object.keys(data)) || 0 : item.fullSlot);
      const minSlot = +(this.useResult ? min(Object.keys(data)) || 0 : item.fullSlot);

      // 引数調整
      this.calcArgs.unionBonus = this.calcArgs.isUnion ? 1.1 : 1;

      const rows = this.defenseShipRows;
      for (let i = 0; i < rows.length; i += 1) {
        const row = rows[i];
        row.disabledASW = false;
        // 防御艦
        const { ship } = row;
        // 潜水かどうか？
        const isSubmarine = ship.data.type === SHIP_TYPE.SS || ship.data.type === SHIP_TYPE.SSV;
        // 対潜攻撃可能かどうか？
        let enableAsw = false;

        // 火力分布
        let powers: PowerDist[] = [];
        if (this.parent instanceof Airbase) {
          // 基地航空隊火力計算
          // 熟練度クリティカルボーナス算出
          this.calcArgs.criticalBonus = item.getProfCriticalBonus();
          powers = Calculator.getAirbaseFirePowers(item, slotDist, ship, this.calcArgs);
          enableAsw = item.data.asw >= 7;
        } else if (this.parent instanceof Ship || this.parent instanceof Enemy) {
          // 通常航空戦火力計算
          powers = Calculator.getAerialFirePowers(item, slotDist, ship, this.calcArgs);
        }

        const isEnemy = ship instanceof Enemy;
        const HP = ship.hp;

        // 火力分布より、被ダメージ分布を取得
        const damageDist = CommonCalc.getDamageDistribution(powers, ship.actualArmor, this.ammo, HP, isEnemy);
        const damages = damageDist.map((v) => v.damage);

        // 最低 最大ダメ
        const minDamage = min(damages) as number;
        const maxDamage = max(damages) as number;

        // 各損傷状態必要ダメージボーダーとその確率 [死, 大, 中]
        const damageBorders = [
          { min: HP, max: maxDamage + 1, rate: 0 },
          { min: Math.ceil(HP * 0.75), max: HP, rate: 0 },
          { min: Math.ceil(HP * 0.5), max: Math.ceil(HP * 0.75), rate: 0 },
        ];

        for (let j = 0; j < damageBorders.length; j += 1) {
          const obj = damageBorders[j];
          const borderMin = obj.min;
          const borderMax = obj.max;
          // 各損傷状態を満たすボーダーを上回る確率を合計したもの => つまり〇〇率
          const okPowers = damageDist.filter((v) => v.damage >= borderMin && v.damage < borderMax).map((v) => v.rate);
          const rate = okPowers.length === damageDist.length ? 1 : (sum(okPowers) as number);
          obj.rate = rate;
        }

        // ダメージ表示調整
        if (!item.data.isAttacker) {
          // 非攻撃機は基本表示なし ただし対潜攻撃可の場合はその限りでない => 水偵とか
          if (!isSubmarine || !enableAsw) {
            row.damage = '';
            row.death = 0;
            row.taiha = 0;
            row.chuha = 0;
            continue;
          }
        }
        if (isSubmarine && !enableAsw) {
          // 対潜攻撃不可
          row.damage = '';
          row.death = 0;
          row.taiha = 0;
          row.chuha = 0;
          row.disabledASW = true;
          continue;
        } else if (maxDamage === 0) {
          if (maxSlot > 0) {
            // 攻撃機かつ搭載数があるのにダメージ0
            row.damage = 'Scratch';
          } else {
            row.damage = '';
          }
        } else if (minDamage === 0) {
          if (minSlot > 0) {
            // 全滅してないのに0なら割合
            row.damage = `Scratch ~ ${maxDamage}`;
          } else {
            row.damage = `0 ~ ${maxDamage}`;
          }
        } else {
          row.damage = `${minDamage} ~ ${maxDamage}`;
        }

        row.death = Math.floor(damageBorders[0].rate * 1000) / 10;
        row.taiha = Math.floor(damageBorders[1].rate * 1000) / 10;
        row.chuha = Math.floor(damageBorders[2].rate * 1000) / 10;
      }
    },
    bootTooltip(item: Item, e: MouseEvent) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (!item.data.id || setting.disabledItemTooltip) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = e.clientX;
        this.tooltipY = rect.y + rect.height;
        this.tooltipItem = item;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
    copySlotRate() {
      const textToCopy = document.getElementById('slot-rate-table-string') as HTMLInputElement;
      textToCopy.classList.remove('d-none');
      textToCopy.select();
      document.execCommand('copy');
      textToCopy.classList.add('d-none');
    },
  },
});
